import { render, staticRenderFns } from "./PublishBulkUploadDialog.vue?vue&type=template&id=59827e51"
import script from "./PublishBulkUploadDialog.vue?vue&type=script&lang=js"
export * from "./PublishBulkUploadDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports